<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {isMobile} from '@/utils/mobile'
import {isEmptyUtils} from '@/utils/data'
export default {
  name: 'App',
  mounted() {
    if(!isEmptyUtils(isMobile()) && this.$route.path != '/m' && (this.$route.path == '/' || this.$route.path == '/pc')) {
      this.$router.push('/m')
    } else if(!isMobile() && this.$route.name != 'Pcindex' && this.$route.name == 'Mindex') {
      this.$router.push('/pc')
    }
  }
}
</script>

<style>
body{
  margin: 0;padding: 0;
}
#app {
  margin: 0;padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue